<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismissExternal"></AlertDismiss>

        <!-- Modal -->
        <b-modal id="linkModal" title="Documento de la declaración" size="xl" centered scrollable
            header-bg-variant="dark" v-model="modalShow" hide-footer>

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>

            </template>

            <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

            <DocumentPdf :pdfUrl="link"></DocumentPdf>

        </b-modal>
    </div>
</template>
<script>
import { EventNames } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import DocumentPdf from '@/components/shared/Document-pdf.vue'

export default {
    name: 'StatementDocument',

    data() {
        return {
            modalShow: false,
            evidenciaRouter: '',
            link: ''
        }
    },

    components: {
        AlertDismiss,
        DocumentPdf,
    },

    async mounted() {
        this.$eventBus.$on(EventNames.OpenModalPepStatementDocument, async (query) => {
            this.reset();
            this.openModal();
            this.evidenciaRouter = query;

            await this.getStatementDocument();
        });
    },

    methods: {
        ...mapActions(["getPepDocumentUrl"]),

        reset() {
            this.evidenciaRouter = '';
            this.link = '';
        },

        openModal() {
            this.modalShow = true;
        },

        closeModal() {
            this.modalShow = false;
        },

        async getStatementDocument() {
            const result = await this.getPepDocumentUrl({ route: this.evidenciaRouter });

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                return;
            }

            this.link = result.data;
        }
    }

}
</script>
<style></style>
